import { HTML, IMAGE, PDF } from '../constants'

const isMenuScrapeable = menuFormat =>
  menuFormat === HTML || menuFormat === PDF || menuFormat === IMAGE

export default isMenuScrapeable
